import React from 'react'
import ErrorIcon from '@mui/icons-material/Error'
import { i18nTranslate } from 'src/utils'
import './styles.scss'

// Shown while the parent gates it on hover/focus; role="status" avoids the assertive interruptions of role="alert".
export const SepaMandateWarningBanner = ({ id = '' }) => {
  return (
    <div
      id={id ? `sepa-warning-${id}` : undefined}
      className="sepa-mandate-warning-banner"
      role="status"
      data-testid="qa-sepa-mandate-warning-banner">
      <ErrorIcon
        fontSize="small"
        aria-hidden="true"
        data-testid="qa-sepa-mandate-warning-icon"
      />
      <span className="sepa-mandate-warning-text">
        {i18nTranslate(
          'payment.sepaMandateSetupInProgress',
          'A SEPA mandate setup is in pending'
        )}
      </span>
    </div>
  )
}

export default SepaMandateWarningBanner
